import { render, staticRenderFns } from "./PreviewProduct.vue?vue&type=template&id=6a5e7b75"
import script from "./PreviewProduct.vue?vue&type=script&lang=js"
export * from "./PreviewProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports